import { fromJS } from "immutable";
import {
  LOAD_RECOMMENDATIONS,
  LOAD_RECOMMENDATIONS_SUCCESS,
  LOAD_RECOMMENDATIONS_ERROR,
  LOAD_RECOMMENDATIONS_PRODUCTS, LOAD_RECOMMENDATIONS_PRODUCTS_SUCCESS, LOAD_RECOMMENDATIONS_PRODUCTS_ERROR
} from "./constants";

const initialStateArticles = fromJS({
  type: "Articles",
  loading: false,
  error: false,
  recommendations: []
});

export function mostVisitedArticlesReducer (state = initialStateArticles, action) {
  switch (action.type) {
    case LOAD_RECOMMENDATIONS:
      return state
        .set("loading", true)
        .set("error", false);
    case LOAD_RECOMMENDATIONS_SUCCESS:
      return state
        .set("recommendations", action.recommendations)
        .set("loading", false);
    case LOAD_RECOMMENDATIONS_ERROR:
      return state.set("error", action.error).set("loading", false);
    default:
      return state;
  }
}

const initialStateProducts = fromJS({
  type: "Products",
  loading: false,
  error: false,
  recommendations: []
});

export function mostVisitedProductsReducer (state = initialStateProducts, action) {
  switch (action.type) {
    case LOAD_RECOMMENDATIONS_PRODUCTS:
      return state
        .set("loading", true)
        .set("error", false);
    case LOAD_RECOMMENDATIONS_PRODUCTS_SUCCESS:
      return state
        .set("recommendations", action.recommendations)
        .set("loading", false);
    case LOAD_RECOMMENDATIONS_PRODUCTS_ERROR:
      return state.set("error", action.error).set("loading", false);
    default:
      return state;
  }
}
